import { Owner } from 'src/features/visitor/types';
import { DAY_OF_WEEK } from 'src/features/membershipType/types';
import { Translation } from 'src/types';

export enum MEMBERSHIP_CATEGORY {
    VIP = 'vip',
    RESIDENT = 'resident',
    STAFF = 'staff',
    SERVICE = 'service',
    SUBSCRIPTION = 'subscription',
    RESERVATION = 'reservation',
}

export type MembershipAllowedTimes = {
    id: string;
    created_at: string;
    modified_at: string;
    day_of_week: DAY_OF_WEEK;
    from_time: string;
    to_time: string;
};

export type Membership = {
    id: string;
    membership_type: {
        category: MEMBERSHIP_CATEGORY;
        is_active: boolean;
        id: string;
        translations: Translation[];
        allow_access_as_client_outside_restrictions: boolean;
        allow_access_over_capacity_limit: boolean;
        apply_pricing_per_space: boolean;
        auto_renew: boolean;
        limit_duration: boolean;
    };
    pricing_plan?: {
        id: string;
        translations: Translation[];
    };
    created_at: string;
    modifier_at: string;
    name: string;
    membership_allowed_times: MembershipAllowedTimes[];
    ref: string;
    max_allowed_spaces_count: number;
    membership_identifiers_count: number;
    in_parking: boolean;
    custom_spaces_definition?: boolean | null;
    description?: string | null;
    valid_from: string;
    valid_to?: string;
    owner?: Owner;
    allowed_spaces?: string[];
};

export enum IDENTIFIER_TYPE {
    LICENSE_PLATE = 'license_plate',
    TICKET = 'ticket',
    ACCESS_KEY = 'access_key',
}

export type MembershipIdentifier = {
    id: string;
    identifier: {
        value: string;
        type: IDENTIFIER_TYPE;
    };
    owner: Owner;
    current_stay: {
        id: string;
        ref: string;
    };
    created_at: string;
    modifier_at: string;
    private_notes?: string;
    public_notes?: string;
};

export enum ACCESS_KEY_TYPE {
    CARD = 'card',
    CHIP = 'chip',
    TAG = 'tag',
    PASSWORD = 'password',
}
export type AccessKey = {
    id: string;
    type: ACCESS_KEY_TYPE;
    value: string;
    modified_at?: string;
    created_at?: string;
    valid_from?: string;
    valid_to?: string;
    pass_back_allowed?: boolean;
};


